import { Injectable } from '@angular/core';
import { Questions } from '@core/generated-gql/graphql';

@Injectable({ providedIn: 'root' })
export class JsonUtilityService {
  constructor() {}

  public replaceUnicodeChars(question: Partial<Questions>, char: string[]) {    
    const joinedStr = char.join('|');    
    const regexp =  RegExp(joinedStr, 'g');
    for (const key in question) {
      if (Object.prototype.hasOwnProperty.call(question, key)) {
        let item = question[key];
        if (typeof item !== 'string') {
          this.replaceUnicodeChars(item, char);
        } else {
          question[key] = item.replace(regexp, "'");
        }
      }
    }
    return question
  }
}
